import axios from "axios";

const API = axios.create({
  baseURL: "https://6253c8b7798ebc565135d54b.mockapi.io",
});
export default API;
